import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { LoginComponent } from './pages/login/login.component';
import { CodigosComponent } from './pages/codigos/codigos.component';
import { ComprobantesComponent } from './pages/comprobantes/comprobantes.component';

const routes: Routes =[
  {
    path: '',
    redirectTo: 'administrar/trabajadores',
    pathMatch: 'full',
  }, {
    path: '',
    component: AdminLayoutComponent,
    children: [
        {
      path: '',
      loadChildren: './layouts/admin-layout/admin-layout.module#AdminLayoutModule'
  }]}, {
    path: 'pages/login',
    component: LoginComponent,
    children: [
        {
      path: '',
      loadChildren: './pages/login/login.module#LoginModule'
  }]}, {
    path: 'codigos/:codigo',
    component: CodigosComponent,
    children: [
        {
      path: '',
      loadChildren: './pages/codigos/codigos.module#CodigosModule'
  }]}, {
    path: 'pages/comprobantes',
    component: ComprobantesComponent,
    children: [
        {
      path: '',
      loadChildren: './pages/comprobantes/comprobantes.module#ComprobantesModule'
  }]}
    // { path: 'dashboard',      component: DashboardComponent },
    // { path: 'user-profile',   component: UserProfileComponent },
    // { path: 'table-list',     component: TableListComponent },
    // { path: 'typography',     component: TypographyComponent },
    // { path: 'icons',          component: IconsComponent },
    // { path: 'maps',           component: MapsComponent },
    // { path: 'notifications',  component: NotificationsComponent },
    // { path: 'upgrade',        component: UpgradeComponent },
    // { path: '',               redirectTo: 'dashboard', pathMatch: 'full' }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes)
  ],
  exports: [
  ],
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app.routing.ts